<template>
  <div class="page">
    <div class="centered-box locations-white locations-generic">
      <div class="row">
        <div class="col">
          <div class="locations-title">Events</div><br>
<strong>Des Plaines River Canoe and Kayak Marathon</strong>
<br><br>
        Race day for the 69th. Des Plaines River Canoe Marathon is <strong>Sunday, May 17</strong>—We will be taking reservations for this event starting <strong>Monday, March 30, 2026.</strong>
<br><br>
Please be aware that before renting from us you’ll first need to register with the event organizers. For more information, visit their Website at: <a href="https://www.canoemarathon.com/"> www.CanoeMarathon.com</a>
<div class="mb-1">
            <!-- <strong>Season:</strong> May - October -->
          </div>
          <two-label-w-link
            :twoLines="true"
            link=""
            linkLabel=""
            firstLabel=""
            secondLabel=""
          />
          <div class="left">
            <a class="Twilight" href="#/Twilight">
        </a>
            <strong>
            
               To rent a canoe or kayak, contact us at:
            <a href="mailto:Info@ChicagoRiverPaddle.com">
          info@ChicagoRiverPaddle.com
            </a> 
            . Please provide your full  name, contact info, number of participants, and the type and number of boats you want to rent.
            </strong>
            <br /><br />

            The course runs 18.5 miles on the Des Plaines River south from Libertyville, Illinois. A shorter event—the 5.25-mile ‘Minithon’—runs from Potawatomi Woods in Wheeling, Illinois. 

<br /><br />
 <strong>
            Pricing:
           
          </strong>
              <br />
              <strong>Full marathon:</strong> Single kayak—$80; Tandem kayak—$120; Canoe—$100
              <br />
              <strong>Mini marathon:</strong> Single kayak—$60; Tandem kayak—$100; Canoe—$80
              <br><br>              
              Rental includes paddles and life jackets. We will have your boats and equipment ready at the start of your event and pick it back up at the finish line.
              <br />

</div>

<br>
<u><strong>Twilight Nature Paddle</strong>–Calander coming soon.</u> 


          <!-- <div class="center">
            68th DesPlaines River Canoe Marathon. We rent canoes and kayaks for
            this event, providing drop off at the start and pick up at the
            finish. Full marathon or mini-thon. PFD's and paddles included.
            Check the event website before reserving your boat.
            <a href="https://www.canoemarathon.com/"
              >(https://www.canoemarathon.com/)</a
            >
            Contact us with event, type of boat and how many at
            <a href="mailto:info@chicagoriverpaddle.com"
              >info@chicagoriverpaddle.com</a
            >
          </div> -->

<!-- 
          <br />

          <table class="table table-bordered">
            <tr>
              <td colspan="4" class="center cell-bg-blue" >2025 Desplaines River Canoe Marathon Prices</td>
            </tr>
            <tr>
              <th center></th>
              <th colspan="3" class="cell-bg-red center"><strong>Boat Type</strong></th>
            </tr>
            <tr>
              <td class="cell-bg-green center"><strong>Event</strong></td>
              <td>Canoe</td>
              <td>Tandem kayak</td>
              <td>Single kayak</td>
            </tr>
            <tr>
              <td>Full Marathon</td>
              <td>$100</td>
              <td>$120</td>
              <td>$80</td>
            </tr>
            <tr>
              <td>Mini-marathon</td>
              <td>$80</td>
              <td>$100</td>
              <td>$60</td>
            </tr>
          </table> -->
          <!-- <br /> -->
          <div>
            <!-- <span class="blue">67th. Des Plaines River Canoe & Kayak Marathon.</span> 
              A big "Thank you!" to everyone who rented kayaks and canoes from us for this year's event. We put 34 boats on the water on what turned out to be a perfect day paddling. We look forward to doing it all again next year.  -->
            <!-- (old code that I could re-use) -->
            <!-- To rent a canoe or kayak, contact us at: <a href="mailto:info@chicagoriverpaddle.com">info@chicagoriverpaddle.com.</a> Please provide your full name, contact info, number of participants, and the type and number of boats you want to rent. -->
            <!-- <br><br> -->
            <!-- Please be aware that before renting from us you’ll first need to register with the event organizers. For more information, visit their Website <strong>at: <a href="https://s2.goeshow.com/dpckm/dpckm/2024/"> www.CanoeMarathon.com</a></strong> -->
            <!-- <br><br>             -->
            <!-- Pricing: -->
            <!-- <br><br> -->
            <!-- Full marathon: Single kayak—$80; Tandem kayak—$120; Canoe—$100 -->
            <br />
            <!-- Mini marathon: Single kayak—$60; Tandem kayak—$100; Canoe—$80 -->
          </div>
          <br />
          <div>
            <!-- We will have your boat(s) ready at the start of the race and pick them up at the finish. Rental includes paddles and life jackets. -->
          </div>
          <!-- <br />
            <two-label-w-link
            :twoLines="true"
            link="FreeCanoeAndKayakEvents"
            linkLabel="FREE CANOE AND KAYAK EVENTS"
            firstLabel=""
            secondLabel=""
          />
          <br />
            <strong><a href="https://fpdcc.com/event/fall-paddle-festival/">
              FALL PADDLE FESTIVAL
            </a>
          </strong>
          <br /> -->
          <!-- <two-label-w-link 
            :twoLines="true"
            link="Exercise" 
            linkLabel="Exercise Classes"
            firstLabel=" - Temporarily unavailable"
            secondLabel="(From Clark Park Boathouse)">
          </two-label-w-link>
           -->
          <!-- <two-label-w-link
            :twoLines="true"
            link="Marathon"
            linkLabel="Des Plaines River Marathon"
            firstLabel=" - You can rent kayaks or canoes from us after Saturday, April 1 but be aware that you'll first need to register with the event organizers. For more information, visit their Website at: <a class='btn-primary btn' href='https://www.CanoeMarathon.com'>www.CanoeMarathon.com.</a> Once that's done, you can then contact us at <a href='mailto:info@chicagoriverpaddle.com'>info@chicagoriverpaddle.com.</a> <span style='color: red'> Please do not call our launch sites to reserve boats for this event.</span>"
          >
          </two-label-w-link> -->

          <!-- <div class="responsiveCal">
            <iframe
              src="https://calendar.google.com/calendar/embed?showTitle=0&amp;showDate=0&amp;showPrint=0&amp;showCalendars=0&amp;showTz=0&amp;height=600&amp;wkst=2&amp;hl=nl&amp;bgcolor=%23FFFFFF&amp;src=example.be_cpkbjcpttgb5q0%40group.calendar.google.com&amp;color=%23ffcf03&amp;ctz=Europe%2FBrussels"
              style="border-width:0"
              width="800"
              height="600"
              frameborder="0"
              scrolling="no"
            ></iframe>
            <iframe
              src="http://calendar.google.com/calendar/embed?src=lel7ed6k30juqmluotan4kca6g%40group.calendar.google.com&ctz=America%2FChicago"
              style="border: 0"
              width="800"
              height="600"
              frameborder="0"
              scrolling="no"
            ></iframe> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TwoLabelWLink from "../TwoLabelWLink";
export default {
  name: "Events",
  components: {
    TwoLabelWLink,
  },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.space {
  display: flex;
  justify-content: space-between;
  width: 300px;
}
.cell-bg-red {
background-color:#f4cccc
}

.cell-bg-green {
background-color: #b6d7a8
}

.cell-bg-blue {
background-color: #cfe2f3;
}

.table-bordered th, .table-bordered td {
  border-color: black;
  text-align: center;
}
.left {
  text-align: left;
  /* font-weight: bolder; */
}
.blue {
  color: #007bff;
  font-weight: bolder;
}
.page {
  background-image: url("../../assets/kayak2.jpg");
  flex-direction: column;
}
.responsiveCal {
  position: relative;
  padding-bottom: 75%;
  height: 0;
  overflow: hidden;
}
.responsiveCal iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
